import React from 'react'
import Bredcrumb from '../Common/Bredcrumb'

const FresherParty = () => {
  return (
    <>
      <Bredcrumb title="Fresher Party" />
        <section className='mt-4'>
            <div class="container">
                <div class="row">
                    <div className="col-lg-4 col-md-6 mb-3">
                        <div className="gallary-block">
                            <div className="position-relative">
                                <img src="img/content/events-01.png" alt="..." />                                           
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-4 col-md-6 mb-3">
                        <div className="gallary-block">
                            <div className="position-relative">
                                <img src="img/content/events-02.png" alt="..." />                                           
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-4 col-md-6 mb-3">
                        <div className="gallary-block">
                            <div className="position-relative">
                                <img src="img/content/events-03.png" alt="..." />                                           
                            </div>
                        </div>
                    </div>
                
                    <div className="col-lg-4 col-md-6 mb-3">
                        <div className="gallary-block">
                            <div className="position-relative">
                                <img src="img/content/events-04.png" alt="..." />                                           
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-4 col-md-6 mb-3">
                        <div className="gallary-block">
                            <div className="position-relative">
                                <img src="img/content/events-05.png" alt="..." />                                           
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-4 col-md-6 mb-3">
                        <div className="gallary-block">
                            <div className="position-relative">
                                <img src="img/content/events-06.png" alt="..." />                                           
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-4 col-md-6 mb-3">
                        <div className="gallary-block">
                            <div className="position-relative">
                                <img src="img/content/events-07.png" alt="..." />                                           
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-4 col-md-6 mb-3">
                        <div className="gallary-block">
                            <div className="position-relative">
                                <img src="img/content/events-08.png" alt="..." />                                           
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-4 col-md-6 mb-3">
                        <div className="gallary-block">
                            <div className="position-relative">
                                <img src="img/content/events-09.png" alt="..." />                                           
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-4 col-md-6 mb-3">
                        <div className="gallary-block">
                            <div className="position-relative">
                                <img src="img/content/events-10.png" alt="..." />                                           
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-4 col-md-6 mb-3">
                        <div className="gallary-block">
                            <div className="position-relative">
                                <img src="img/content/events-11.png" alt="..." />                                           
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-4 col-md-6 mb-3">
                        <div className="gallary-block">
                            <div className="position-relative">
                                <img src="img/content/events-12.png" alt="..." />                                           
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-4 col-md-6 mb-3">
                        <div className="gallary-block">
                            <div className="position-relative">
                                <img src="img/content/events-13.png" alt="..." />                                           
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-4 col-md-6 mb-3">
                        <div className="gallary-block">
                            <div className="position-relative">
                                <img src="img/content/events-14.png" alt="..." />                                           
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-4 col-md-6 mb-3">
                        <div className="gallary-block">
                            <div className="position-relative">
                                <img src="img/content/events-14.png" alt="..." />                                           
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-4 col-md-6 mb-3">
                        <div className="gallary-block">
                            <div className="position-relative">
                                <img src="img/content/events-15.png" alt="..." />                                           
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-4 col-md-6 mb-3">
                        <div className="gallary-block">
                            <div className="position-relative">
                                <img src="img/content/events-16.png" alt="..." />                                           
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-4 col-md-6 mb-3">
                        <div className="gallary-block">
                            <div className="position-relative">
                                <img src="img/content/events-17.png" alt="..." />                                           
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-4 col-md-6 mb-3">
                        <div className="gallary-block">
                            <div className="position-relative">
                                <img src="img/content/events-18.png" alt="..." />                                           
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-4 col-md-6 mb-3">
                        <div className="gallary-block">
                            <div className="position-relative">
                                <img src="img/content/events-19.png" alt="..." />                                           
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-4 col-md-6 mb-3">
                        <div className="gallary-block">
                            <div className="position-relative">
                                <img src="img/content/events-20.png" alt="..." />                                           
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-4 col-md-6 mb-3">
                        <div className="gallary-block">
                            <div className="position-relative">
                                <img src="img/content/events-21.png" alt="..." />                                           
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-4 col-md-6 mb-3">
                        <div className="gallary-block">
                            <div className="position-relative">
                                <img src="img/content/events-22.png" alt="..." />                                           
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-4 col-md-6 mb-3">
                        <div className="gallary-block">
                            <div className="position-relative">
                                <img src="img/content/events-23.png" alt="..." />                                           
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-4 col-md-6 mb-3">
                        <div className="gallary-block">
                            <div className="position-relative">
                                <img src="img/content/events-24.png" alt="..." />                                           
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </>
  )
}

export default FresherParty
